import type { VendorTracker } from '../useConversionTracker';
import { createVendorTracker } from './createVendorTracker';

declare global {
  interface Window {
    fbq?: (command: string, event: string, params?: Record<string, unknown>) => void;
    _fbq?: unknown;
  }
}

export const facebookConversionTracker: VendorTracker = createVendorTracker({
  vendor: 'facebook',
  fire(vendorEventName, callback) {
    if (typeof window.fbq !== 'function') {
      console.warn('[FacebookConversionTracker] fbq is not loaded — skipping');
      callback?.();
      return;
    }
    try {
      window.fbq('trackCustom', vendorEventName);
      callback?.();
    } catch (err) {
      console.error('[FacebookConversionTracker] fbq threw unexpectedly', err);
      callback?.();
    }
  },
});
